import React, { useEffect, useState } from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import { FaTable } from "react-icons/fa";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import TextField from "components/ui/controls/text-field/text-field";
import { FaCalculator, FaSync } from "react-icons/fa";
import { CalculPrestationContrat, CalculRetraite } from "components/app/Api/Retraite/ApiRetraite";
import InfoMessage from "components/ui/controls/info-message/info-message";
import { createStyledButton } from "components/ui/controls/button/button-styles";
const PrestationsPerp = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  const [AnnneDepartRetraite, SetAnneeDepartRetraite] = useState(0);
  const handleCalculRetraite = () => {
    CalculRetraite(context.state, "", 0, ClientConjoint).then((ResultatRetraite) => {
      CalculPrestationContrat(context.state, ClientConjoint, ResultatRetraite, "").then((Resultat) => {
        context.handleValueChange("CotisationContratRetraite", Resultat.TabCotisations);
        context.handleValueChange("TableauSaisieManuelleRente", Resultat.TabPrestations);
        SetAnneeDepartRetraite(Number(ResultatRetraite.RetraiteChoixDepartRetraite.Infos.DateDepartRetraite.slice(0, 4)));
      });
    });
  };
  useEffect(() => {
    handleCalculRetraite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Column fill>
        <CardBox bpad>
          <Column fill>
            <Column fill>
              <Row>
                <InfoMessage
                  text=" Les prestations sont automatiquement calculées en fonction des paramètres que vous avez renseignés. Vous avez toutefois la possibilité de modifier directement le montant
                  dans les cases."
                />
              </Row>
            </Column>
            <Row style={{ marginTop: "0px" }}>
              <Column fill>
                <CardBoxHeader icon={<FaTable style={{ color: "#6b7280", fontSize: 14 }} />}>
                  <span style={{ color: "rgb(55, 65, 81)", fontSize: 14, fontWeight: 600, fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif", letterSpacing: "-0.01em" }}>
                    Tableau des prestations périodiques
                  </span>
                </CardBoxHeader>
                {/* Column headers for the list */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 700,
                    margin: "8px 0 8px 0",
                    paddingLeft: 0,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    fontSize: 13,
                    color: "#64748b",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                  }}
                >
                  <span style={{ minWidth: 70, marginRight: 18 }}></span>
                  <span
                    style={{
                      minWidth: 50,
                      marginRight: 18,
                      textAlign: "center",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: 13,
                      color: "#64748b",
                      fontWeight: 600,
                      marginLeft: "30px",
                    }}
                  >
                    Age
                  </span>
                  <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block", marginLeft: "80px" }}>Rente brute annuelle</span>
                  <span style={{ width: 180, marginRight: 18, textAlign: "center", display: "inline-block" }}>Capital au terme</span>
                  <span style={{ flex: 1 }}></span>
                </div>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    width: "100%",
                    maxWidth: 700,
                    marginLeft: 0,
                    marginRight: 0,
                    display: "block",
                  }}
                >
                  {AnnneDepartRetraite > 0 &&
                    [0, 1, 2, 3, 4].map((offset) => {
                      const Annee = AnnneDepartRetraite + offset;
                      if (!context.state.TableauSaisieManuelleRente?.[Annee]) return null;
                      return (
                        <li
                          key={Annee}
                          style={{
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                            padding: "8px 0 8px 12px",
                            marginBottom: "14px",
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            border: "1.5px solid #d1d5db",
                            transition: "box-shadow 0.2s",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 700,
                              fontSize: "12px",
                              color: " #6366f1",
                              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                              minWidth: 70,
                              marginRight: 18,
                              background: "#f1f5ff",
                              border: "1.5px solid #6366f1",
                              borderRadius: "8px",
                              padding: "4px 12px",
                              display: "inline-block",
                            }}
                          >
                            Année {context.state.TableauSaisieManuelleRente[Annee]["AnneeDepartRetraiteAffich"]}
                          </span>
                          <span
                            style={{
                              fontSize: "12px",
                              color: " #64748b",
                              fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",

                              minWidth: 50,
                              marginRight: 18,
                            }}
                          >
                            {context.state.TableauSaisieManuelleRente[Annee]["Age"]}
                          </span>
                          <TextField
                            iconBefore={
                              <Button
                                icon
                                onClick={(e) => {
                                  context.handleSaisieManuelleRente(Annee, "RenteSaisi", e);
                                }}
                                {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                              >
                                {!context.state.TableauSaisieManuelleRente[Annee]["RenteSaisi"] ? <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />}
                              </Button>
                            }
                            value={context.state.TableauSaisieManuelleRente[Annee]["Rente"]}
                            disabled={context.state.SortieContratRetraite === "RenteCapital" ? true : false}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            onChange={(e) => {
                              context.handleSaisieManuelleRente(Annee, "Rente", e);
                            }}
                            style={{
                              width: "160px",
                              marginRight: 18,
                            }}
                          />
                          <TextField
                            iconBefore={
                              <Button
                                icon
                                onClick={(e) => {
                                  context.handleSaisieManuelleRente(Annee, "PartProduitSaisi", e);
                                }}
                                {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                              >
                                {!context.state.TableauSaisieManuelleRente[Annee]["PartProduitSaisi"] ? <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />}
                              </Button>
                            }
                            value={Number(context.state.TableauSaisieManuelleRente[Annee]["PartVersement"]) + Number(context.state.TableauSaisieManuelleRente[Annee]["PartProduit"])}
                            disabled={context.state.SortieContratRetraite === "RenteSimple" ? true : false}
                            onChange={(e) => {
                              context.handleSaisieManuelleRente(Annee, "PartProduit", e);
                            }}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            style={{
                              width: "160px",
                              marginRight: 18,
                            }}
                          />
                          <span style={{ flex: 1 }}></span>
                        </li>
                      );
                    })}
                  {/* Taux plein */}
                  {AnnneDepartRetraite > 0 && context.state.TableauSaisieManuelleRente?.["TauxPlein"] && (
                    <li
                      key="TauxPlein"
                      style={{
                        background: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                        padding: "8px 0 8px 12px",
                        marginBottom: "14px",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",

                        border: "1.5px solid #d1d5db",
                        transition: "box-shadow 0.2s",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "12px",
                          color: " #6366f1",
                          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                          minWidth: 70,
                          marginRight: 18,
                          background: "#f1f5ff",
                          border: "1.5px solid #6366f1",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          display: "inline-block",
                        }}
                      >
                        Taux plein
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                          minWidth: 50,
                          marginRight: 18,
                        }}
                      >
                        {context.state.TableauSaisieManuelleRente["TauxPlein"]["Age"]}
                      </span>
                      <TextField
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleSaisieManuelleRente("TauxPlein", "RenteSaisi", e);
                            }}
                          >
                            {!context.state.TableauSaisieManuelleRente["TauxPlein"]["RenteSaisi"] ? <FaCalculator /> : <FaSync style={{ color: "green" }} />}
                          </Button>
                        }
                        value={context.state.TableauSaisieManuelleRente["TauxPlein"]["Rente"]}
                        disabled={context.state.SortieContratRetraite === "RenteCapital" ? true : false}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        onChange={(e) => {
                          context.handleSaisieManuelleRente("TauxPlein", "Rente", e);
                        }}
                        style={{
                          width: "160px",
                          marginRight: 18,
                        }}
                      />
                      <TextField
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleSaisieManuelleRente("TauxPlein", "PartProduitSaisi", e);
                            }}
                          >
                            {!context.state.TableauSaisieManuelleRente["TauxPlein"]["PartProduitSaisi"] ? <FaCalculator /> : <FaSync style={{ color: "green" }} />}
                          </Button>
                        }
                        value={Number(context.state.TableauSaisieManuelleRente["TauxPlein"]["PartVersement"]) + Number(context.state.TableauSaisieManuelleRente["TauxPlein"]["PartProduit"])}
                        onChange={(e) => {
                          context.handleSaisieManuelleRente("TauxPlein", "PartProduit", e);
                        }}
                        disabled={context.state.SortieContratRetraite === "RenteSimple" ? true : false}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                        style={{
                          width: "160px",
                          outline: "none",

                          marginRight: 18,
                        }}
                      />
                      <span style={{ flex: 1 }}></span>
                    </li>
                  )}
                </ul>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>

    </>
  );
};

export default PrestationsPerp;
